import PropTypes, { bool, func, string, node } from 'prop-types';
import CheckFilled from '@alltrails/shared/icons/CheckFilled';
import * as styles from './styles/styles.module.scss';

const ShareModalDrawer = ({ showSuccessIcon, onClick, imgLink, icon, title }) => {
  const Icon = icon || <img className={styles.icon} src={imgLink} alt={title} />;

  return (
    <div className={styles.container} onClick={onClick} role="button">
      <div className={styles.shareDrawer}>
        <div className={styles.shareImageContainer}>{Icon}</div>
        <div className={styles.title}>{title}</div>
        {showSuccessIcon && <CheckFilled size="md" />}
      </div>
    </div>
  );
};

ShareModalDrawer.propTypes = {
  showSuccessIcon: bool,
  onClick: func,
  imgLink: string,
  icon: node,
  title: PropTypes.oneOfType([string, node])
};

ShareModalDrawer.defaultProps = {
  showSuccessIcon: false,
  onClick: () => {},
  imgLink: '',
  icon: null,
  title: ''
};

export default ShareModalDrawer;
